import { findIndex } from 'lodash';

export function setSurchargeHotel({ action, state, surcharges }) {
    const listItems = [...state.detail.reservations];
    const detailIndex = findIndex(listItems, item => {
        return item.id === action.params.itemVariantId
    })
    if (detailIndex >= 0) listItems[detailIndex].setDetail({ ...action.params, surcharges: surcharges });
    return listItems
}

export function generateStringId(length) {
    let result           = '';
    const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }

 export const soioStatus = {
    SUCCESS: 'success',
    PUSHED: 'pushed',
    UNHANDLE:'unhandle',
 }

 export const soioStatuscolor = (status) => {
    if (!status) return "blue"
    switch (status) {
    case soioStatus.SUCCESS:
        return "green";
    case soioStatus.PUSHED:
        return "red";
    case soioStatus.UNHANDLE:
        return "blue";
    default:
        return "yellow"
}}